module.exports = __webpack_public_path__ + "img/spouse.45e794be.svg";